<label class="checkbox-container">
  <input type="checkbox" #checkbox [(ngModel)]="status">
  <span class="checkmark"></span>
</label>